var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60229 4.7072L7.99989 7.9056L14.3975 4.7072C14.3738 4.29955 14.1952 3.91639 13.8982 3.63618C13.6011 3.35597 13.2082 3.19992 12.7999 3.2H3.19989C2.79156 3.19992 2.39865 3.35597 2.10164 3.63618C1.80462 3.91639 1.62598 4.29955 1.60229 4.7072Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4001 6.4944L8.0001 9.6944L1.6001 6.4944V11.2C1.6001 11.6243 1.76867 12.0313 2.06873 12.3314C2.36878 12.6314 2.77575 12.8 3.2001 12.8H12.8001C13.2244 12.8 13.6314 12.6314 13.9315 12.3314C14.2315 12.0313 14.4001 11.6243 14.4001 11.2V6.4944Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.30edc472378163dc92cac09a307d21ab.svg";
export { ForwardRef as ReactComponent };